export default "__VITE_ASSET__BIQt2jij__"